import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';

@Component({
  selector: 'vi-breadcrumbs',
  standalone: true,
  imports: [CommonStandaloneModule, RouterLink],
  templateUrl: 'breadcrumbs.component.html',
  styleUrls: ['breadcrumbs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViBreadcrumbsComponent {
  @Input() formerPage: string;
  @Input() currentPage: string;
  @Input() navigateTo: string;
  @Input() paramsHandling = null;
}
